import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchApproveRejectRequestEmbryoTransferRightPurchaceAgreementthunk,
  FetchCancelRequestthunk,
  FetchCreateEmbryoTransferRightPurchaceAgreementServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchOwnerCoveringCertificatesDropDownthunk,
  FetchUpdateEmbryoTransferRightPurchaceAgreementServiceRequestthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import AsyncSelect from "react-select/async";
import axiosInstance from "../axios/axios";
import Popup from "reactjs-popup";
import dayjs from "dayjs";
import EahsForm from "../components/EahsForm";
import PillBtn from "../components/PillBtn";
import ApproveBtn from "../components/servicesButtons/ApproveBtn";
import ApproveAndPayBtn from "../components/servicesButtons/ApproveAndPayBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import RejectBtn from "../components/servicesButtons/RejectBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import CancelBtn from "../components/servicesButtons/CancelBtn";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import CustomPopUp from "../components/CustomPopUp";

export default function RequestEmbryoTransferRightPurchaceAgreement() {
  //env
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  //const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    ownerCoveringCertificatesDropDownData,
    createEmbryoTransferRightPurchaceAgreementServiceRequestData
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));

  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    coveringCertificate: "",
    coveringCertificateDrop: {
      label: translate("web.coveringCertificate", "Covering Certificate"),
      value: null,
    },
    mareHorse: "",
    stallionHorse: "",
    mareOwner: "",
    stallionOwner: "",
    breeder: "",
    coveringDate: "",

    buyer: "",
    buyerDrop: {
      label: translate("web.owner", "owner"),
      value: null,
    },

    phone: "",
    email: "",
    idNumber: "",

    agreementDate: null,

    newBreeder: "Seller",

    eventName: "",
    comment: "",
    buyerComment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",
    embryoTransferRightPurchaceAgreementId: null,
  });

  const [errorCoveringCertificate, setErrorCoveringCertificate] = useState(false);

  const [errorBuyer, setErrorBuyer] = useState(false);

  const [errorAgreementDate, setErrorAgreementDate] = useState(false);

  // state ref
  const coveringCertificateRef = useRef(null);
  const buyerRef = useRef(null);
  const agreementDateRef = useRef(null);

  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  const [timeoutId, setTimeoutId] = useState(0);

  const [inputValue, setInputValue] = useState("");

  const [openPopup, setOpenPopup] = useState(false);

  const [openPopupCancel, setOpenPopupCancel] = useState(false);

  const _status = useRef("");

  const _isOnlinePayment = useRef("");

  //function
  const handleFormChange = (e, input) => {
    if (input === "coveringCertificate") {
      let coveringCertificate = ownerCoveringCertificatesDropDownData.filter((item) => item.id == e.value);
      setFormModel({
        ...formModel,
        coveringCertificate: e.value,
        coveringCertificateDrop: e,
        mareHorse: coveringCertificate[0]?.mare ?? "",
        stallionHorse: coveringCertificate[0]?.stallion ?? "",
        mareOwner: coveringCertificate[0]?.mareOwner ?? "",
        stallionOwner: coveringCertificate[0]?.stallionOwner ?? "",
        coveringDate: coveringCertificate[0]?.coveringDate ?? "",
        breeder: coveringCertificate[0]?.breeder ?? "",
      });
    } else if (input === "buyer") {
      if (e?.value != null && e?.value != undefined) {
        setFormModel({
          ...formModel,
          buyer: e.value,
          buyerDrop: e,
          email: e.details.email,
          phone: e.details.phone,
          idNumber: e.details.idNumber,
        });
      }
    } else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.coveringCertificate === ""
    ) {
      setErrorCoveringCertificate(true);
      valid = false;

      coveringCertificateRef?.current?.focus();
      return;
    }
    else {
      setErrorCoveringCertificate(false);
    }

    if (
      formModel.buyer === ""
    ) {
      setErrorBuyer(true);
      valid = false;

      buyerRef?.current?.focus();
      return;
    }
    else {
      setErrorBuyer(false);
    }

    if (
      formModel.agreementDate === null
    ) {
      setErrorAgreementDate(true);
      valid = false;

      agreementDateRef?.current?.focus();
      return;
    }
    else {
      setErrorAgreementDate(false);
    }

    //terms
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckTerm", "Please Check Term")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status , buttonAction='Draft') => {
    _status.current = status;
    if (
      validInputs()
    ) {
      let params = {
        id: id,
        status: status,
        eventName: formModel.eventName,
        buyerComment: formModel.buyerComment,

        ownerId: getUserID(),
        buyerId: formModel.buyer,
        coveringCertificateId: formModel.coveringCertificate,
        agreementDate: dayjs(formModel.agreementDate).format("DD/MM/YYYY"),
        newBreeder: formModel.newBreeder,
        buttonAction: buttonAction,

        // serviceDefinitionId: serviceId,
        // createdBy: localStorage.getItem("EAHSUserID"),
      };

      //if (action == null) {
      dispatch(FetchCreateEmbryoTransferRightPurchaceAgreementServiceRequestthunk(params));
      // } else if (action === "edit" || formModel.eventName === "SentBack") {
      //   dispatch(FetchUpdateEmbryoTransferRightPurchaceAgreementServiceRequestthunk(params));
      // }
    }
    else {
      toast.error(
        translate("web.completeTheRequiredData", "Complete The Required Data")
      );
    }
  };

  const handelSelectedAccountChange = async (element) => {
    dispatch(FetchOwnerCoveringCertificatesDropDownthunk(element.value));

    setProfile(element);

    setFormModel({
      ...formModel,
      coveringCertificate: "",
      coveringCertificateDrop: {
        label: translate("web.coveringCertificate", "Covering Certificate"),
        value: null,
      },
      mareHorse: "",
      stallionHorse: "",
      mareOwner: "",
      stallionOwner: "",
      breeder: "",
      coveringDate: "",
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      ?.ownersPermissionsList.some(
        (x) =>
          x.permissionName === "EmbryoPurchaceAgreement" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  const handelCancelRequest = () => {
    let params = {
      serviceId: id,
      ownerId: localStorage.getItem("EAHSUserID"),
    };

    dispatch(FetchCancelRequestthunk(params));
  };

  const handelApproveRejectRequest = (status, isOnlinePayment) => {
    _status.current = status;
    _isOnlinePayment.current = isOnlinePayment;

    let params = {
      id: id,
      ownerId: getUserID(),
      status: status,
      buyerComment: formModel.buyerComment,
    };

    dispatch(FetchApproveRejectRequestEmbryoTransferRightPurchaceAgreementthunk(params));
  };

  const closeModal = () => setOpenPopup(false);

  const closeModalCancel = () => setOpenPopupCancel(false);

  // asyunc search
  const promiseOptions = (searchKeyword) =>
    new Promise((resolve) => {
      if (timeoutId > 0) {
        clearTimeout(timeoutId);
      }

      const id = setTimeout(async () => {
        const response = await axiosInstance.post(
          "/StudBook/FilterOwnersOrUsers",
          {
            langauge: localStorage.getItem("eahsLang") ?? "en",
            ownerId: searchKeyword,
            skip: 0,
            take: 10000,
            tableType: "user",
          }
        );

        const data = await response.data.ownersList;

        const options = data.map((item) => ({
          label: item.ownerId + " - " + item.name,
          value: item.id,
          details: item,
        }));
        resolve(options);
      }, 1000);

      setTimeoutId(id);
    });

  const handelDisabledButton = () => {
    if (
      action === "view" || action === "approve"
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelCancelButton = () => {
    if (
      action === "edit" && formModel.eventName !== "Draft"
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelDraftSubmitButtons = () => {
    if (
      action == null
      || action === "edit"
      || (action === "approve" && formModel.eventName === "SentBack")
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelApproveRejectButtons = () => {
    if (
      action === "approve" && formModel.eventName !== "SentBack"
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    dispatch(FetchOwnerCoveringCertificatesDropDownthunk(getUserID()));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));


    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (
      getServicesRequestByIdData != null && Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId === serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
        embryoTransferRightPurchaceAgreementId: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.embryoTransferRightPurchaceAgreementId,
        buyerComment: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.buyerComment != null ? getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.buyerComment : "",

        coveringCertificate: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.coveringCertificateId,
        coveringCertificateDrop: {
          label: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.referenceNumber + " / " + translate("web.mare", "Mare") + ": " + getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.mare + " / " + translate("web._stallion", "Stallion") + ": " + getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.stallion,
          value: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.coveringCertificateId,
        },

        mareHorse: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.mare,
        stallionHorse: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.stallion,
        mareOwner: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.mareOwner,
        stallionOwner: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.stallionOwner,
        coveringDate: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.coveringDate,
        breeder: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.breeder,

        buyer: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.buyerId,
        buyerDrop: {
          label:
            getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerCode +
            " - " +
            getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerName,
          value: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.buyerId,
        },
        phone: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerPhone,
        email: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerEmail,
        idNumber: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.idNumber,

        agreementDate: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.agreementDate != null ? dayjs(getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.agreementDate).format("YYYY-MM-DD") : null,
        newBreeder: getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.newBreeder,

      });

      //another owner
      if (
        getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerId !==
        getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice" &&
        getServicesRequestByIdData.eventName !== "WaitingBuyerApproval" &&
        getServicesRequestByIdData.eventName !== "SentBack"
      ) {
        dispatch(FetchOwnerCoveringCertificatesDropDownthunk(getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerId));

        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.embryoTransferRightPurchaceAgreement.ownerId
          )[0].value,
        });
      }

      //options
      // setCheckedItems({
      //   option1: true
      // });
    }

  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    //save
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_status.current === "Approve") {
        toast.success(
          translate(
            "web.yourRequestHasSuccessfully",
            "Your Request Has Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());
      const newId = id == null ? createEmbryoTransferRightPurchaceAgreementServiceRequestData?.id : id;
      if (getServiceDefinitionByIdData.serviceFees > 0) {
        setTimeout(() => {

          if (_status.current === "Approve") {
            const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${newId}`;

            const encodeURI = encodeURIComponent(returnUrl);

            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${newId}&paymentType=12&userId=${localStorage.getItem(
              "EAHSUserID"
            )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
          } else {
            if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
              navigate(`/profile?activeTab=${"e_services"}&serviceId=${newId}`);
            }
            else {
              navigate(`/profile?activeTab=${"e_services"}`);
            }
          }
        }, 1000);
      }
      else {
        if (_status.current === "Approve") {
          setTimeout(() => {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${newId}`);
          }, 1000);
        }
        else if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
          setTimeout(() => {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${newId}`);
          }, 1000);
        }
        else {
          setTimeout(() => {
            navigate(`/profile?activeTab=${"e_services"}`);
          }, 1000);
        }
      }
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  })

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>
      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      {/* content page */}
      <div className={serviceRequestHeadContainer}>
        {/* Request Embryo Transfer Right Purchace Agreement*/}
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>
        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName().registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      {/* Covering Certificate details*/}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.coveringCertificateDetails", "Covering Certificate Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.coveringCertificate", "Covering Certificate")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.coveringCertificate", "Covering Certificate"),
                value: "",
              },
              ...(!!ownerCoveringCertificatesDropDownData &&
                ownerCoveringCertificatesDropDownData.map((a) => ({
                  label: a.referenceNumber + " / " + translate("web.mare", "Mare:") + ": " + a.mare + " / " + translate("web._stallion", "Stallion:") + ": " + a.stallion,
                  value: a.id,
                }))),
            ]}
            value={formModel.coveringCertificateDrop}
            onChange={(e) => handleFormChange(e, "coveringCertificate")}
            placeholder={translate("web.coveringCertificate", "Covering Certificate")}
            name={"coveringCertificate"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"horse"}
            isDisabled={handelDisabledButton()}
            ref={coveringCertificateRef}
          />

          {errorCoveringCertificate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}

        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.mare", "Mare")}
            name={"mareHorse"}
            type={"text"}
            disabled={true}
            value={formModel.mareHorse}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.mareOwner", "Mare Owner")}
            name={"mareOwner"}
            type={"text"}
            disabled={true}
            value={formModel.mareOwner}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.breeder", "Breeder")}
            name={"breeder"}
            type={"text"}
            disabled={true}
            value={formModel.breeder}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web._stallion", "Stallion")}
            name={"stallionHorse"}
            type={"text"}
            disabled={true}
            value={
              formModel.stallionHorse
            }
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.stallionOwner", "stallion Owner")}
            name={"stallionOwner"}
            type={"text"}
            disabled={true}
            value={formModel.stallionOwner}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.coveringDate", "CoveringDate")}
            name={"coveringDate"}
            type={"text"}
            disabled={true}
            value={formModel.coveringDate !== "" ? dayjs(formModel.coveringDate).format("DD/MM/YYYY") : formModel.coveringDate}
          />
        </div>
      </EahsForm>

      {/* Buyer details*/}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.buyerDetails", "Buyer Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.owner", "Owner")}
            <i className=" colorred"> *</i>
          </label>
          <AsyncSelect
            isClearable
            loadOptions={promiseOptions}
            defaultOptions={false} // Set to true to load initial options
            onInputChange={(newValue) => setInputValue(newValue)}
            inputValue={inputValue}
            value={formModel.buyerDrop}
            loadingMessage={() => translate("web.loading", "Loading")}
            onChange={(e) => handleFormChange(e, "buyer")}
            placeholder={
              translate("web.typeToSearch", "Type To Search") + "..."
            }
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            isDisabled={handelDisabledButton()}
            ref={buyerRef}
          />

          {errorBuyer && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.smsPhoneNo", "Mobile No")}
            name={"mobileNo"}
            type={"text"}
            disabled={true}
            value={formModel.phone}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate(
              "web.passportOrEmiratesId",
              "Passport - EmiratesId"
            )}
            name={"name"}
            type={"text"}
            disabled={true}
            value={formModel.idNumber}
            isDash={true}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.email", "Email")}
            name={"email"}
            type={"text"}
            disabled={true}
            value={formModel.email}
          />
        </div>
      </EahsForm>

      {/* agreement Details */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.agreementDetails", "Agreement Details")}>
        <div className={eformInput}>
          <NetaqInput
            htmlTags={
              formModel.agreementDate ?
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  {
                    dayjs(formModel.agreementDate).format("DD/MM/YYYY")
                  }
                </p> :
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  DD/MM/YYYY
                </p>
            }
            name={"agreementDate"}
            type={"normalDateService"}
            label={translate("web.agreementDate", "Agreement Date")}
            onChange={(e) => handleFormChange(e, "agreementDate")}
            value={formModel.agreementDate}
            required={true}
            minDate={dayjs(formModel.coveringDate).format("YYYY-MM-DD")}
            maxDate={dayjs().format("YYYY-MM-DD")}
            disabled={
              (action === "approve" || action === "view") ?
                true
                : false
            }
            ref={agreementDateRef}
          />
          {errorAgreementDate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={"row " + eformInput}>
          <label>
            {translate("web.newBreeder", "New Breeder")}
          </label>
          <div className={eformCheckBox}>
            <NetaqInput
              name={"newBreeder"}
              type={"radioServiceRequest"}
              value={"Seller"}
              label={`${translate("web.seller", "Seller")}-`}
              onChange={handleFormChange}
              checked={
                formModel.newBreeder === "Seller"
              }
              disabled={handelDisabledButton()}
            />
          </div>

          <div className={eformCheckBox}>
            <NetaqInput
              name={"newBreeder"}
              type={"radioServiceRequest"}
              value={"Buyer"}
              label={`${translate("web.buyer", "buyer")}-`}
              onChange={handleFormChange}
              checked={
                formModel.newBreeder === "Buyer"
              }
              disabled={handelDisabledButton()}
            />
          </div>
        </div>

      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment ||
        !!formModel.buyerComment ||
        action === "approve") && (
          <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
            {/* eahs Comment */}
            {!!formModel.comment && (
              <div className={eformInput}>
                <NetaqInput
                  label={translate("web.eahsComments", "EAHS Comments")}
                  name={"adminComment"}
                  type={"textarea"}
                  maxchars={1150}
                  value={formModel.comment}
                  disabled={true}
                />
              </div>
            )}
            {/* buyer Comment */}
            {(action === "approve" ||
              (action === "edit" && formModel.eventName === "BuyerRejected") ||
              (action === "view" && !!formModel.buyerComment)) && (
                <div className={eformInput}>
                  <NetaqInput
                    label={translate("web.buyerComment", "Buyer Owner Comment")}
                    name={"buyerComment"}
                    type={"textarea"}
                    placeholder={translate(
                      "web.buyerComment",
                      "Buyer Owner Comment"
                    )}
                    maxchars={1150}
                    onChange={handleFormChange}
                    value={formModel.buyerComment}
                    disabled={
                      action === "approve"
                        ?
                        false
                        : true
                    }
                  />
                </div>
              )}
          </EahsForm>
        )}

      {/* terms */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons */}
      <div className={eFormButtonsContainer}>
        {handelCancelButton() && (
          <CancelBtn onClick={() => {
            setOpenPopupCancel((o) => !o);
          }} />
        )}

        {handelDraftSubmitButtons() && (
          <>
            {(formModel.eventName === "" || formModel.eventName === "Draft") &&
              <DraftBtn onClick={() => handelFormSubmit("Draft",'Draft')}
                isDisabled={
                  formModel.eventName === "" ||
                    formModel.eventName === "Draft"
                    ? false
                    : true
                } />
            }

            <SubmitServiceBtn
              onClick={() =>
                handelFormSubmit("Submit","Submit")
              }
            />
          </>
        )}

        {handelApproveRejectButtons() && (
          //reject/approve btns
          <>
            <RejectBtn
              spanText={translate(
                "web.rejectBuyerComments",
                "*To Reject The Request Please Enter The Buyer Comment*"
              )}
              onClick={() => {
                setOpenPopup((o) => !o);
              }}
              isDisabled={
                formModel.requestsType === "Portal" &&
                  !!formModel.buyerComment
                  ? false
                  : true
              }
            />

            {getServiceDefinitionByIdData.serviceFees > 0 && (
              <>
                {userProfile?.participateWithoutPayment == true && (
                  <ApproveAndPayLaterBtn
                    selectedAccountId={profile?.value}
                    onClick={() =>
                      handelApproveRejectRequest("Approve", "no")
                    } />
                )}
                <ApproveAndPayBtn selectedAccountId={profile?.value} onClick={() =>
                  handelApproveRejectRequest("Approve", "yes")
                } />
              </>
            )}

            {getServiceDefinitionByIdData.serviceFees === 0 && (
              <ApproveBtn onClick={() =>
                handelApproveRejectRequest("Approve")
              } />
            )}
          </>
        )}
      </div>

      {/* pop up */}
      <CustomPopUp
        title={translate(
          "web.confirmMsgRejectrequest",
          "Are you sure to reject request?"
        )}
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        btnText={translate("web.reject", "Reject")}
        onClick={() => {
          setOpenPopup((o) => !o);
          handelApproveRejectRequest("Reject");
        }} />

      {/* pop up for cancel */}
      <CustomPopUp
        title={translate(
          "web.confirmMsgCancelRequest",
          "Are you sure to cancel request?"
        )}
        btnText={translate("web.cancel", "Cancel")}
        open={openPopupCancel}
        onClose={() => {
          setOpenPopupCancel(false);
        }}
        onClick={() => {
          setOpenPopupCancel((o) => !o);
          handelCancelRequest();
        }}
      />
    </>
  );
}
